export default __webpack_public_path__ + "static/media/Logo_Color_Resize.de1868b0.png";